import React from "react";
import { translate } from "application/functions";

const StepTitle = (props) => {
  const { step } = props;

  const steps = [
    translate("step1.title"),
    translate("step2.title"),
    translate("step3.title"),
    translate("step4.title"),
    translate("step5.title"),
  ];

  return (
    <div className="form__form-body-title">
      <div className="title-steps">{steps[step]}</div>
    </div>
  );
};

export default StepTitle;
